import React from 'react';
import PropTypes from 'prop-types';
import {Message} from '../';
import Spacer from '../common/spacer/Spacer';


const RedeemError = ({supportName, supportUrl}) => {
    return (
        <Spacer className="container min-height" top={40}>
            <Message as="p" code="epic.esport.entitlement.info" />
            <ol>
                <Message as="li" code="epic.esport.entitlement.reason.verifying" />
                <Message as="li" code="epic.esport.entitlement.reason.account" />
                <Message as="li" code="epic.esport.entitlement.reason.noId" />
            </ol>
            <Message
                as="p"
                code="errors.com.epicgames.ecommerce.payout.loseEntitlement"
                args={[supportUrl, supportName]}
            />
        </Spacer>
    );
};

RedeemError.propTypes = {
    supportName: PropTypes.string,
    supportUrl: PropTypes.string
};

export default RedeemError;
